import PrimaryButton from 'components/button/PrimaryButton';
import SubmitFlexBox from 'components/container/SubmitFlexBox';
import { theme } from 'utils/style/theme';
import styled from 'styled-components';
import React, { useState, useEffect, useCallback } from 'react';
import {
  IBubbleSet,
  IPrimeCurrency,
  IProject,
  IProjectType,
  ISupportLanguage,
} from 'utils/types/storyTypes';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import DefaultTextArea from 'components/input/DefaultTextArea';
import DefaultInput from 'components/input/DefaultInput';
import { storyApi } from 'apis/story/storyApis';
import SelectStyled from 'components/SelectStyled';
import refreshPage from 'utils/helper/refreshPage';

interface IProps {
  langList: ISupportLanguage[] | null;
  data: IProject | null;
}

interface ValueOption {
  value: string;
  label: string;
}

const FormRightContent: React.FC<IProps> = ({ langList, data }) => {
  const { t } = useTranslation();
  const [projectTypeList, setProjectTypeList] = useState<IProjectType[]>([]);
  const [bubbleSetList, setBubbleSetList] = useState<IBubbleSet[]>();
  const [primeCurrencyList, setPrimeCurrencyList] = useState<IPrimeCurrency[]>(
    [],
  );
  const [supportLangList, setSupportLangList] = useState<
    ISupportLanguage[] | null
  >(null);

  const [valueProjectType, setValueProjectType] = useState<ValueOption>({
    value: '',
    label: '',
  });
  const [valueBubbleSet, setValueBubbleSet] = useState<ValueOption>({
    value: '',
    label: '',
  });
  const [valuePrimeCurrency, setValuePrimeCurrency] = useState<ValueOption>({
    value: '',
    label: '',
  });
  const [valueSupportLang, setValueSupportLang] = useState<ValueOption>({
    value: '',
    label: '',
  });
  const [isCancelButtonDisabled, setCancelButtonDisabled] = useState(true);

  const checkFieldHasChange = (
    newValue: string | null,
    oldValue: string | null,
  ) => {
    console.log('newValue:', newValue);
    console.log('oldValue:', oldValue);
    if (newValue == oldValue) {
      setCancelButtonDisabled(true);
      return;
    }
    setCancelButtonDisabled(false);
  };

  const fetchProjectTypeList = async () => {
    const res = await storyApi.projectTypeList();
    setProjectTypeList(res);
  };

  const fetchBubbleListData = async () => {
    const res = await storyApi.bubbleList('KO');
    setBubbleSetList(res.filter((v) => v.bubble_ver >= 100));
  };
  const fetchPrimeCurrencyList = async () => {
    const res = await storyApi.primeCurrencyList('KO');
    setPrimeCurrencyList(res);
  };
  const fetchSupportLangListData = async () => {
    const res = await storyApi.supportLang();
    setSupportLangList(res);
  };
  useEffect(() => {
    fetchBubbleListData();
    fetchSupportLangListData();
    fetchProjectTypeList();
    fetchPrimeCurrencyList();
  }, []);

  const foundValue = useCallback((value, dataList) => {
    const itemFound = dataList?.find(
      (option) => `${option.code}` === `${value}`,
    );
    if (itemFound) {
      return {
        value: itemFound.code,
        label: itemFound.code_name,
      };
    }
    return {
      value: '',
      label: '',
    };
  }, []);

  const setValueForm = () => {
    if (data) {
      setValueProjectType(foundValue(data?.project_type, projectTypeList));
      setValueBubbleSet(foundValue(data?.bubble_set_id, bubbleSetList));
      setValuePrimeCurrency(
        foundValue(data?.prime_currency_text_id, primeCurrencyList),
      );
      setValueSupportLang(foundValue(data?.default_lang, supportLangList));
    }
  };

  useEffect(() => {
    setValueForm();
  }, [data]);
  const handleCancel = () => {
    if (!isCancelButtonDisabled) {
      setValueForm();
      setCancelButtonDisabled(true);
    }
  };

  const handleSubmit = async () => {
    if (data && !isCancelButtonDisabled) {
      const valuesForm = {
        ...data,
        project_type: valueProjectType.value,
        default_lang: valueSupportLang.value,
        bubble_set_id: Number(valueBubbleSet.value),
        prime_currency_text_id: Number(valuePrimeCurrency.value),
      };

      await storyApi.updateDetailStory(data.project_id, valuesForm);
      refreshPage();
    }
  };

  return (
    <>
      <OtomeProjectContentWrapper>
        <SectionWarpper>
          <p className='title'>{t('updateStory.form.storyType')}</p>
          <div></div>
          <SelectStyled
            size='large'
            bordered={false}
            value={valueProjectType}
            style={{ width: '100%' }}
            onChange={(value, option) => {
              setValueProjectType(option as any);
              checkFieldHasChange(
                `${value}`,
                foundValue(data?.project_type, projectTypeList).value,
              );
            }}
            options={projectTypeList?.map((v, i) => {
              return {
                value: v.code,
                label: v.code_name,
              };
            })}
          />
        </SectionWarpper>

        <SectionWarpper>
          <p className='title'>{t('updateStory.form.speechBubble')}</p>
          <SelectStyled
            size='large'
            bordered={false}
            value={valueBubbleSet}
            style={{ width: '100%' }}
            onChange={(value, option) => {
              setValueBubbleSet(option as any);
              checkFieldHasChange(
                `${value}`,
                foundValue(data?.bubble_set_id, bubbleSetList).value,
              );
            }}
            options={bubbleSetList?.map((v, i) => {
              return {
                value: v.code,
                label: v.code_name,
              };
            })}
          />
        </SectionWarpper>
        <SectionWarpper>
          <p className='title'>{t('updateStory.form.mainCurrency')}</p>
          <SelectStyled
            size='large'
            bordered={false}
            value={valuePrimeCurrency}
            // suffixIcon={
            //   <img src={isOpen ? arrowUp : arrowDown} alt="arrow" />
            // }
            style={{ width: '100%' }}
            onChange={(value, option) => {
              setValuePrimeCurrency(option as any);
              checkFieldHasChange(
                `${value}`,
                foundValue(data?.prime_currency_text_id, primeCurrencyList)
                  .value,
              );
            }}
            options={primeCurrencyList?.map((v, i) => {
              return {
                value: v.code,
                label: v.code_name,
              };
            })}
          />
        </SectionWarpper>
        <SectionWarpper>
          <p className='title'>{t('updateStory.form.producePackageID')}</p>
          <DefaultInput
            title=''
            name='productPackageId'
            value={data?.produce_package_id ? data.produce_package_id : ''}
            style={{
              background: theme.colors.dark_50,
            }}
            disabled
          />
        </SectionWarpper>
        <SectionWarpper>
          <p className='title'>{t('updateStory.form.bundleID')}</p>
          <DefaultInput
            title=''
            name='productBundleID'
            value={data?.bundle_id ? data.bundle_id : ''}
            style={{
              background: theme.colors.dark_50,
            }}
            disabled
          />
        </SectionWarpper>
        <SectionWarpper>
          <p className='title'>{t('updateStory.form.defaultLanguage')}</p>
          <SelectStyled
            size='large'
            bordered={false}
            value={valueSupportLang}
            // suffixIcon={
            //   <img src={isOpen ? arrowUp : arrowDown} alt="arrow" />
            // }
            style={{ width: '100%' }}
            onChange={(value, option) => {
              setValueSupportLang(option as any);
              checkFieldHasChange(
                `${value}`,
                foundValue(data?.default_lang, supportLangList).value,
              );
            }}
            options={langList?.map((v, i) => {
              return {
                value: v.code,
                label: v.code_name,
              };
            })}
          />
        </SectionWarpper>

        <SubmitFlexBox style={{ columnGap: 12 }}>
          <>
            <PrimaryButton
              text={t('updateStory.form.buttonCancel')}
              height='40px'
              width='151px'
              bgColor='#FFFF'
              textColor={theme.colors.dark_400}
              fontWeight={theme.fontWeights.medium}
              fontSize={theme.fontSizes.normal}
              border={`1px solid ${theme.colors.gray_6}`}
              rounded='6px'
              hoverBgColor={'#FFFF'}
              activeBgColor={'#FFFF'}
              selectedBgColor={'#FFFF'}
              onClick={handleCancel}
              disabled={isCancelButtonDisabled}
            />
            <PrimaryButton
              text={t('updateStory.form.buttonSubmit')}
              height='40px'
              width='151px'
              bgColor={theme.colors.blue_500}
              textColor='#ffffff'
              fontWeight={theme.fontWeights.medium}
              fontSize={theme.fontSizes.normal}
              border={`1px solid ${theme.colors.blue_500}`}
              rounded='6px'
              hoverBgColor={theme.colors.blue_600}
              activeBgColor={theme.colors.blue_800}
              selectedBgColor={theme.colors.blue_700}
              onClick={handleSubmit}
              disabled={isCancelButtonDisabled}
            />
          </>
        </SubmitFlexBox>
      </OtomeProjectContentWrapper>
    </>
  );
};

export default FormRightContent;

const OtomeProjectContentWrapper = styled.div`
  & > * + * {
    margin-top: 16px;
  }
  .title {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
  .ant-input-disabled {
    color: ${theme.colors.dark_300};
  }
`;
